import { ReactElement, SVGProps } from "react"

import { IconProps } from "../icon.types"

export const IconRegulations = ({ hovered, ...props }: IconProps) => {
  if (hovered) return <IconRegulationsHovered {...props} />
  else return <IconRegulationsDefault {...props} />
}

const IconRegulationsDefault = (
  props: SVGProps<SVGSVGElement>
): ReactElement<SVGElement> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9.615 20h-2.615a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8" />
    <path d="M14 19l2 2l4 -4" />
    <path d="M9 8h4" />
    <path d="M9 12h2" />
  </svg>
)

const IconRegulationsHovered = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor" // Fill the entire icon for the hover effect
    stroke="currentColor" // Use the current color for stroke as well
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9.615 20h-2.615a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8" />
    <path d="M14 19l2 2l4 -4" />
    <path d="M9 8h4" />
    <path d="M9 12h2" />
  </svg>
)
